/**
 * Notification bar
 */
var cor_data_layer_clicks = function(e) {

  if (e.target.matches('a[data-click-data-layer]')) {
      var btn = e.target;
      if ( btn.hasAttribute('data-click-data-layer') ) {
        var isTargetBlank = (btn.hasAttribute('target') && btn.getAttribute('target') == '_blank');
        // check if target is blank
        if (!isTargetBlank) {
          e.preventDefault();
        }
        var data = JSON.parse(btn.getAttribute('data-click-data-layer'));
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(data);
        console.log('push click event', data);
        if (!isTargetBlank) {
          setTimeout(function(btn) {
            if (btn.hasAttribute('href')) {
              window.location.href = btn.getAttribute('href');
            }
          }, 300, btn);
        }
      }
  }
};

document.body.addEventListener('click', cor_data_layer_clicks);
